import { saveAs } from 'file-saver';
import { pdf } from '@react-pdf/renderer';
import { ResultTablePDF } from "../components/ResultTablePDF";
import { SummaryTablePDF } from "../components/SummaryTablePDF";
import Row from '../types/Row';
import TableRowType from '../types/TableRowType'
import ApiDataService from "../services/ApiDataService";

const generateResultsTablePdf = async (props: { results: any, discount: any, total: any, productName: any, summaryText: any, countryCode?: string }, fileName: string) => {
  const { results, discount, total, productName, summaryText, countryCode } = props;
  const blob = await pdf((
    <ResultTablePDF results={results} discount={discount} total={total} productName={productName} fieldSummary={summaryText} countryCode={countryCode} fileName={fileName} />
  )).toBlob();
  saveAs(blob, fileName);
};

const generateSummaryTablePdf = async (props: { summaryTable: any, countryCode?: string }, fileName: string) => {
  const { summaryTable, countryCode } = props;
  const blob = await pdf((
    <SummaryTablePDF summaryTable={summaryTable} countryCode={countryCode} fileName={fileName} />
  )).toBlob();
  saveAs(blob, fileName);
};


const sumUp = (rows: Row[]): Row => {

  if (rows.length == 0) {
    throw Error("Table of rows should not be empty.");
  }

  let amount = 0;
  let weight = 0;
  let netto = 0;
  for (const row of rows) {
    amount += row.amount;
    weight += row.weight;
    netto += row.netPrice;

  }
  return {
    art: rows[0].art,
    term: rows[0].term,
    amount: amount,
    discount: rows[0].discount,
    fullPrice: rows[0].fullPrice,
    weight: weight,
    netPrice: netto,
    sortOrder: rows[0].sortOrder
  }
}

const generateCombinedSummaryTablePdf = async (props: { summaryTable: any, countryCode?: string }, fileName: string) => {
  const map = new Map<string, Row[]>();
  const { summaryTable, countryCode } = props;

  let description = "";
  let netPrice = 0;
  
  for (const val of summaryTable) {
    description += val.name + ", " + val.description + "\n";
    netPrice += val.netPrice;
    for (const row of val.row) {
      const value = map.get(row.art) ?? [];
      value.push(row)
      map.set(row.art, value);
    }
  }

  let rows = Array.from(map, ([_, value]) => sumUp(value));

  let results = (await ApiDataService.optimizeArticlePackages(rows, countryCode || "")).rows;
  results.sort((a, b) => a.sortOrder - b.sortOrder)
  const combinedSummaryTable: TableRowType = {
    name: "",
    description: description,
    netPrice: netPrice,
    row: results
  };
  
  const blob = await pdf((
    <SummaryTablePDF summaryTable={[combinedSummaryTable]} countryCode={countryCode} fileName={fileName} />
  )).toBlob();
  saveAs(blob, fileName);
};

export { generateResultsTablePdf, generateSummaryTablePdf, generateCombinedSummaryTablePdf };
